import { Row, Col, Card, Dropdown } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import JobPic from "../../app/assets/images/ewa (13) 1.png";
import RecruitmentCard from "./cards/RecruitmentCard";
import { useNavigate } from "react-router-dom";
import ResumeList from "./ResumeList";
import OfferLetterOptionModal from "../offer-letter/Modal/OfferLetterOptionModal";
import { useState } from "react";

const RecruitmentBody = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => setIsModalVisible(true);
  const handleCancel = () => setIsModalVisible(false);
  const navigate = useNavigate();

  return (
    <>
      <Row justify="center">
        <Col span={24}>
          <Card
            className="post-job-card cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-xl"
            onClick={() => {
              navigate(`job-openings`);
            }}
          >
            <Dropdown className="dropdown-btn" trigger={["click"]}>
              <button className="modal-btn">
                <EllipsisOutlined className="dropdownIcon" />
              </button>
            </Dropdown>

            <div className="flex flex-col md:flex-row justify-between">
              <div className="text-side">
                <h2 className="title">Post Job Openings</h2>
                <p className="cardDes">Please provide your update when you have a moment so we can keep everything moving smoothly.</p>
              </div>

              <img src={JobPic} alt="Your Logo" className="icon2" />
            </div>
          </Card>
        </Col>
      </Row>
      <div className="mt-9">
        <RecruitmentCard isVisible={showModal} />
      </div>
      <Row justify="center">
        <Col span={24}>
          <div className="mt-9">
            <ResumeList />
          </div>
        </Col>
      </Row>
      <OfferLetterOptionModal isVisible={isModalVisible} onCancel={handleCancel} />
    </>
  );
};

export default RecruitmentBody;
